import React from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { FormControl, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { IdPickerProps, IdPickerSchema } from './schema';
import { useAsync } from 'react-use';
import { useApi } from '@backstage/core-plugin-api';

const IdPicker = (props: IdPickerProps) => {
  const {
    onChange,
    required,
    schema: { title = 'Id' },
    uiSchema,
    rawErrors,
    idSchema,
  } = props;
  const kind = uiSchema['ui:options']?.kind as string;

  const catalogApi = useApi(catalogApiRef);

  const { value: entities, loading } = useAsync(async () => {
    const { items } = await catalogApi.getEntities({
      filter: { kind },
    });
    return items;
  });

  const ids = entities?.map(e => parseInt(e.metadata.name, 10)) ?? [];

  let newId = '1';

  if (ids.length !== 0) {
    newId = (Math.max(...ids) + 1).toString();
  }

  onChange(newId);

  return (
    <FormControl required={required} error={rawErrors?.length > 0 && !newId}>
      <Autocomplete
        id={idSchema?.$id}
        value={newId}
        disabled
        loading={loading}
        options={[newId] || []}
        autoSelect
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            required={required}
            InputProps={params.InputProps}
          />
        )}
      />
    </FormControl>
  );
};

export const IdPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'IdPicker',
    component: IdPicker,
    schema: IdPickerSchema,
  }),
);
